/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { UserSession, UserSession$inboundSchema } from "./usersession.js";

export type GatewaySessionsResult = {
  items: Array<UserSession>;
  nextCursor?: string | undefined;
};

/** @internal */
export const GatewaySessionsResult$inboundSchema: z.ZodMiniType<
  GatewaySessionsResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(UserSession$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function gatewaySessionsResultFromJSON(
  jsonString: string,
): SafeParseResult<GatewaySessionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GatewaySessionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GatewaySessionsResult' from JSON`,
  );
}
